import React from "react";

function GspIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="100%"
      height="100%s"
      fill="none"
      viewBox="0 0 16 16"
    >
      <path
        fill="currentColor"
        d="M8.523 2.052V.5h-1.5v1.552A6.008 6.008 0 001.825 7.25H.273v1.5h1.552a6.006 6.006 0 005.198 5.198V15.5h1.5v-1.552a6.005 6.005 0 005.198-5.198h1.552v-1.5h-1.552a6.005 6.005 0 00-5.198-5.198zM7.773 12.5a4.504 4.504 0 01-4.5-4.5c0-2.482 2.018-4.5 4.5-4.5s4.5 2.018 4.5 4.5-2.018 4.5-4.5 4.5z"
      ></path>
    </svg>
  );
}

export default GspIcon;
